import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.less']
})
export class ErrorPopupComponent implements OnInit {

  @Input() uniqueEmailError: any;
  @Input() uniqueMobileError: any;
  @Input() CBPDError: any;
  @Input() profileSyncError: any;
  errMsg: any;
  showErrorFlag: boolean = false;
  rewardconsumed : boolean = false;
  constructor(
		private modalService: NgbModal
	) { }

  ngOnInit() {
    this.errMsg = "";
    if(this.uniqueEmailError){
      if(this.uniqueEmailError && this.uniqueEmailError.email[0].code == 'unique') {
        this.errMsg = 'Email ID already exist! Please try again';
      } else {
        this.errMsg = this.uniqueEmailError.email[0].message;
      }
    }
   else if(this.uniqueMobileError){
    if(this.uniqueMobileError && this.uniqueMobileError.mobile[0].code == 'unique') {
      this.errMsg = 'Mobile No. already exist! Please try again';
    } else {
      this.errMsg = this.uniqueMobileError.mobile[0].message;
    }
   } 
   else if(this.profileSyncError) {
    this.errMsg = 'Please wait for the profile to sync. Close this window and remain on the current GPMS page. Click the "Enroll" button again. No extra data input required.';
   }
   else {
    this.errMsg=this.CBPDError;
   }
  }
  close() {
		this.modalService.dismissAll();
	}

}
